// extracted by mini-css-extract-plugin
module.exports = {"title-wrapper":"_1fvFz","titleWrapper":"_1fvFz","done":"jhY8-","collapsed":"_28VjM","title":"_3CyMu","checkmark":"_33hm0","textButton":"gqwjx"};